import { useEffect, useState } from "react";
import Sliders from "services/sliders/Sliders";
import HeroSlider from "./HeroSlider";
import HeroVideoSlider from "./HeroVideoSlider";

function HeroBanner() {
  const [config, setConfig] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await Sliders.welcomePageSlider();
        setConfig(res);
      } catch (e) {
        setConfig(null);
      } finally {
        setIsLoading(false);
      }
    };
    fetchConfig();
  }, []);

  if (isLoading) return null;

  if (config?.type === "banner") {
    return <HeroVideoSlider data={config?.data} />;
  }

  return <HeroSlider />;
}

export default HeroBanner;
